import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
const updateMultipleSecondHandSuppliesMutation = gql`mutation update_multiple_second_hand_supplies($idArray:[uuid!]){
  update_second_hand_supplies(where:{id:{_in:$idArray}},
  _set:{status: "PENDING_APPROVAL"}){
    affected_rows
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class SendForApprovalMultipleSecondHandSuppliesService {

  constructor(private apollo: Apollo) { }

  updateMultipleSecondHandSupplies(idArray: any){
    return this.apollo.use('external').mutate({
      mutation: updateMultipleSecondHandSuppliesMutation,
      variables:{
        idArray
      }
    }).toPromise();
  }
}
